import { enableProdMode, ErrorHandler, provideAppInitializer, inject, Injector, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { GlobalErrorHandler, moduleHttpLoaderFactory } from './modules/global';
import { RECAPTCHA_LANGUAGE, RecaptchaV3Module, RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { HTTP_INTERCEPTORS, HttpBackend } from '@angular/common/http';
import { TokenInterceptor } from './app/interceptors/token.interceptor';
import { RouteInterceptor } from './app/interceptors/route.interceptor';
import { CacheInterceptor } from './app/interceptors/cache.interceptor';
import { HttpErrorInterceptor } from './app/interceptors/error.interceptor';
import { LoggerInterceptor } from './app/interceptors/logger.interceptor';
import { applicationTranslationInitializerFactory } from './app/app.config';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { SharedModule } from './modules/shared/shared.module';
import { GlobalModule } from './modules/global/global.module';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app/app.routing';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './app/+state';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
          BrowserModule,
          SharedModule.forRoot(),
          RecaptchaV3Module,
          RecaptchaModule,
          RecaptchaFormsModule,
          GlobalModule,
          TranslateModule.forRoot({
            extend: true,
            loader: {
                provide: TranslateLoader,
                useFactory: moduleHttpLoaderFactory,
                deps: [HttpBackend]
            }
        }),
          StoreModule.forRoot(reducers, { metaReducers }), StoreDevtoolsModule.instrument({
            maxAge: 10, // Retains last 10 states
            logOnly: environment.production // Restrict extension to log-only mode
            ,
            connectInZone: true
        }),
          EffectsModule.forRoot([])),
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        },
        {
            provide: RECAPTCHA_LANGUAGE,
            useValue: 'hu' // use Hungarian language
        },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: RouteInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoggerInterceptor, multi: true },
        provideAppInitializer(() => {
            const initializerFn = (applicationTranslationInitializerFactory)(inject(TranslateService), inject(Injector));
            return initializerFn();
        }),
        provideAnimations(),
        provideRouter(appRoutes)
    ]
})
  .catch((err) => console.error(err));
